<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0 text-center">
    Copyright &copy; {{ currentDate | date: 'yyyy' }} <a id="pixinventLink"
                                                         href="https://pulseright.io">Pulseright</a>
    <span
      class="d-none d-sm-inline-block">, All rights reserved. {{ organizationGroup?.countryCode === 'AU' ? 'TURNTECH AUSTRALIA PTY LTD' : 'TURNTECH INDIA PVT LTD' }}</span>
  </p>
</footer>
<!--Footer Ends-->
